import React from "react";
import cx from "classnames";
import { Route, Routes, Navigate, Outlet } from "react-router-dom";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import axios from "../utils/axiosInstance";
import { makeStyles } from "@material-ui/core/styles";
import ApproveWithdrawReq from "views/Pages/approveWithdrawReq.js";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import AddTemplate from "views/Pages/addTemplate";
import routes from "routes.js";
import styles from "assets/jss/material-dashboard-pro-react/layouts/adminStyle.js";
import AddUser from "views/Pages/addUser";
import CreateLottery from "views/Pages/CreateLottery";
import AddWithdrawal from "views/Pages/addWithdrawal.js";
import ManagePermissions from "views/Pages/ManagePermissions";
import KYCDetailPage from "views/Pages/KYCDetailPage";
import AddFAQ from "views/Pages/addFaq";
import AddMethod from "views/Pages/AddMethods";
import EditMethods from "views/Pages/EditMethods";
import EditLottery from "views/Pages/editLottery";
import EditWithdrawal from "views/Pages/editWithdrawal";
import EditUser from "views/Pages/editUser";

import ViewLottery from "views/Pages/viewLottery";
import { useAuth } from "AuthContext";
import MyAccount from "views/Pages/MyAccount";
import EditAccount from "views/Pages/EditAccount";
import ResetPassword from "views/Pages/ResetPassword";

const useStyles = makeStyles(styles);

export default function Dashboard(props) {
  const { ...rest } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [miniActive, setMiniActive] = React.useState(false);
  const [walletBal, setWalletBal] = React.useState(0);
  const [image, setImage] = React.useState(
    require("assets/img/sidebar-2.jpg").default
  );
  const [color, setColor] = React.useState("blue");
  const [bgColor, setBgColor] = React.useState("black");
  const [logo, setLogo] = React.useState(
    require("assets/img/logoCrypto.svg").default
  );
  const { filteredRoutes } = useAuth();
  const classes = useStyles();
  const mainPanelClasses =
    classes.mainPanel +
    " " +
    cx({
      [classes.mainPanelSidebarMini]: miniActive,
      [classes.mainPanelWithPerfectScrollbar]:
        navigator.platform.indexOf("Win") > -1,
    });

  const mainPanel = React.createRef();
  React.useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      try {
        const data = await axios.get(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/fetchManagerAddressBalance`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        setWalletBal(data.data.data);
      } catch (error) {
        console.error(error.message);
        if (
          error?.response?.data?.message ==
          "For security reasons, we locked your account.Please login to continue"
        ) {
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      }
    };
    fetchData();
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/full-screen-maps";
  };
  const getActiveRoute = (route) => {
    let activeRoute = "";
    let routes = [...route];
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views, []);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  const getRoutes = (routes) => {
    var newRoutes = [
      ...routes,
      {
        path: "my-account",
        name: "My Account",
        component: MyAccount,
        layout: "/admin",
      },
      {
        path: "edit-account",
        name: "Edit Account",
        component: EditAccount,
        layout: "/admin",
      },
      {
        path: "reset-password",
        name: "Reset Password",
        component: ResetPassword,
        layout: "/admin",
      },
      {
        path: "addTemplate",
        name: "Reset Password",
        rtlName: "عالتسعير",
        mini: "MA",
        rtlMini: "ع",
        component: AddTemplate,
        layout: "/admin",
      },

      {
        path: "editMethods",
        name: "Edit Methods",
        rtlName: "عالتسعير",
        mini: "MA",
        rtlMini: "ع",
        component: EditMethods,
        layout: "/admin",
      },


      {
        path: "addWithdrawal",
        name: "Add withdrawal",
        rtlName: "عالتسعير",
        mini: "MA",
        rtlMini: "ع",
        component: AddWithdrawal,
        layout: "/admin",
      },

      {
        path: "editWithdrawal/:paymentId",
        name: "Edit Withdrawal",
        rtlName: "عالتسعير",
        mini: "MA",
        rtlMini: "ع",
        component: EditWithdrawal,
        layout: "/admin",
      },

      {
        path: "addMethod",
        name: "Add Method",
        rtlName: "عالتسعير",
        mini: "AF",
        rtlMini: "ع",
        component: AddMethod,
        layout: "/admin",
      },

      {
        path: "kycDetail",
        name: "KYC Detail",
        rtlName: "عالتسعير",
        mini: "kyc",
        rtlMini: "ع",
        component: KYCDetailPage,
        layout: "/admin",
      },
      {
        path: "userWithdrawRequest/:paymentId",
        name: "User Withdraw Request",
        rtlName: "عالتسعير",
        mini: "kyc",
        rtlMini: "ع",
        component: ApproveWithdrawReq,
        layout: "/admin",
      },
    ];
    return newRoutes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views, []);
      }
      if (prop.children && prop.children.length > 0) {
        return (
          <Route key={key} path={prop.path} element={<prop.component />}>
            {getRoutes(prop.children)}
          </Route>
        );
      }
      if (prop.layout === "/admin") {
        return (
          <Route
            key={key}
            path={prop.path}
            element={<prop.component />}
          ></Route>
        );
      } else {

        return null;
      }
    });
  };

  const sidebarMinimize = () => {
    setMiniActive(!miniActive);
  };

  return (
    <div className={classes.wrapper}>
      <Sidebar
     
        routes={filteredRoutes}
 
        logoText={`Crypto-Lottery-Manager`}
        managerBalance={`Wallet Bal: $ ${walletBal}`}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        bgColor={bgColor}
        miniActive={miniActive}
        {...rest}
      ></Sidebar>
      <div className={mainPanelClasses} ref={mainPanel}>
        <AdminNavbar
          sidebarMinimize={sidebarMinimize.bind(this)}
          miniActive={miniActive}
          
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />


        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>

              <Routes>
                {" "}
                {getRoutes(routes)}

              </Routes>

            </div>
          </div>
        ) : (
          <div className={classes.map}>

          </div>
        )}


      </div>
    </div>
  );
}
